<template>
  <hr class="horizontal dark mt-0 mb-4" />
  <div class="card-body p-3 pt-0">
    <div class="d-sm-flex justify-content-between">
      <div>
        <!-- <soft-button
      class="btn-icon ms-2 export"
      size
      color="success"
      variant="outline"
      @click="$router.push('/stores/new-store')"
    >
      <span class="btn-inner--icon">
        <i class="ni ni-single-02"></i>
      </span>
      <span class="btn-inner--text"> New Store</span>
    </soft-button> -->
      </div>
      <div class="d-flex">
        <!-- <div class="dropdown d-inline">
      <soft-button
        id="navbarDropdownMenuLink2"
        color="dark"
        variant="outline"
        class="dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        >Filters</soft-button
      >
      <ul
        class="dropdown-menu dropdown-menu-lg-start px-2 py-3"
        aria-labelledby="navbarDropdownMenuLink2"
        style
      >
        <li>
          <a class="dropdown-item border-radius-md" href="javascript:;"
            >Status: Paid</a
          >
        </li>
        <li>
          <a class="dropdown-item border-radius-md" href="javascript:;"
            >Status: Refunded</a
          >
        </li>
        <li>
          <a class="dropdown-item border-radius-md" href="javascript:;"
            >Status: Canceled</a
          >
        </li>
        <li>
          <hr class="horizontal dark my-2" />
        </li>
        <li>
          <a
            class="dropdown-item border-radius-md text-danger"
            href="javascript:;"
            >Remove Filter</a
          >
        </li>
      </ul>
    </div> -->
        <soft-button
          class="btn-icon ms-2 export"
          size
          color="dark"
          variant="outline"
          data-type="csv"
        >
          <span class="btn-inner--icon">
            <i class="ni ni-archive-2"></i>
          </span>
          <span class="btn-inner--text">Export CSV</span>
        </soft-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
          <div class="table-responsive">
            <div class="search-bar">
              <soft-input @input="searchForOrder" placeholder="Search By ID">
              </soft-input>
            </div>
            <div class="table-wrapper">
              <table id="store-list" class="table table-hover">
                <thead class="thead-light">
                  <tr>
                    <th>Client</th>
                    <th>Store Name</th>
                    <th>Store ID</th>
                    <th>Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="store in queriedData"
                    :key="store.id"
                    class="table-row"
                    data-bs-toggle="modal"
                    data-bs-target="#Modal"
                    @click="viewStoreDetails(store)"
                  >
                    <td>
                      <div class="align-items-center">
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ store.client.company }}
                        </p>
                      </div>
                    </td>
                    <td class="text-xs font-weight-bold">
                      <div class="align-items-center">
                        <div class="align-items-center">
                          <span>
                            {{ store.storeName }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="align-items-center">
                        <!-- <soft-checkbox /> -->
                        <p class="text-xs font-weight-bold ms-2 mb-0">
                          {{ store.storeId }}
                        </p>
                      </div>
                    </td>

                    <td class="text-xs font-weight-bold">
                      <div class="align-items-center">
                        <div class="align-items-center">
                          {{
                            `${store.address.addressOne}, ${store.address.city}, ${store.address.state}, ${store.address.zipCode}`
                          }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination-wrapper">
              
              <pagination
                :value="pagination.currentPage"
                class="pagination-no-border pagination-success"
                :per-page="pagination.perPage"
                :total="total"
                :from="from"
                :to="to"
                @input="handlePagination"
              >
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <modal
      @close="(showModal = false), (selectedStore = {})"
      :styleFormat="{ width: '1000px', marginLeft: '-10.75rem' }"
      :showSaveBtn="false"
    >
      <template v-slot:title>
        <h2>Store Details</h2>
      </template>
      <template v-slot:body>
        <div class="store-details-wrapper">
          <StoreDetails :store="selectedStore" />
        </div>
      </template>
    </modal> -->
</template>
  
<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import SoftInput from "@/components/SoftInput.vue";
import Modal from "@/components/Modal.vue";
import Pagination from "@/components/Pagination.vue";

import {
  collection,
  db,
  getDocs,
  where,
  query,
} from "@/config/firebaseInit.js";

export default {
  name: "StoreTable",
  components: {
    SoftButton,
    SoftAvatar,
    SoftCheckbox,
    SoftInput,
    Modal,
    Pagination,
  },
  props: {
    rep: {
      type: Object,
      default() {
        return Object;
      },
    },
  },
  data() {
    return {
      tableData: [],
      stores: [],
      showModal: false,
      selectedStore: {},
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [250, 500, 1000],
        total: 0,
      },
      currentSort: "name",
      currentSortOrder: "asc",
      filterBy: {
        rep: "",
        status: "",
        customers: [],
        startDate: "",
        endDate: "",
      },
    };
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data.
     */
    queriedData() {
      let result = this.tableData;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
  },
  created() {
    this.fetchAllStores();
  },
  methods: {
    async fetchAllStores() {
      let storeQuery = query(
        collection(db, "stores"),
        where("storeId", "in", this.rep.stores)
      );
      const stores = await getDocs(storeQuery);
      this.stores = stores.docs.map((user) =>
        Object.assign({ id: user.id }, user.data())
      );
      this.tableData = this.stores;
    },
    fetchrepStores() {},
    handlePagination(value) {
      this.pagination.currentPage = value;
    },
    viewStoreDetails(store) {
      this.selectedStore = store;
      setTimeout(() => {
        this.showModal = true;
      }, 1000);
    },
    searchForOrder(e) {
      let input = e.target.value;
      if (!input) {
        this.tableData = this.store;
      }
      this.tableData = this.orders.filter((store) => store.id.includes(input));
    },
  },
};
</script>
  <style>
.table-row {
  cursor: pointer;
}

.search-bar {
  position: relative;
  width: 200px;
  top: 10px;
  left: 10px;
}

.pagination-wrapper {
  padding: 20px;
}
</style>
  